import gql from 'graphql-tag'

export const CountryFragment = gql`
  fragment Country on country {
    id
    name
    nationality
  }
`
